enum JobType {
  FULL_TIME = 'full time',
  PART_TIME = 'part time',
  INTERNSHIP = 'internship',
  UNKNOWN = 'unknown',
}

export default JobType;
